const useStyles = theme => ({
    text: {
      padding: '3px 8px 3px 8px'
    }
});

export default useStyles
